import { render, staticRenderFns } from "./vehicleMonthlyReport.vue?vue&type=template&id=08f5d948&scoped=true&"
import script from "./vehicleMonthlyReport.vue?vue&type=script&lang=js&"
export * from "./vehicleMonthlyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5d948",
  null
  
)

export default component.exports